import { Observable } from 'rxjs';
import { httpClient } from './shop-context';
import { Basket, PaymentMethod, BasketPrices, BasketPricesForOrderTypes } from '../models/basket';
import { Price } from '../models/shop';
import { LocationProductOrderProposal } from '../models/order';
import { PaymentPageResponse } from '../models/paymentpageresponse';
import { Inventory } from '../models/inventory';

export class ShopService {
	private _url = 'connect/store';

	order(model: Basket): Observable<PaymentPageResponse> {
		const url = `/${this._url}/order`;

		model['returnUrl'] = window.location.href;
		return httpClient.post<PaymentPageResponse>(url, model);
	}

	getTotalPrice(model: Basket): Observable<BasketPricesForOrderTypes> {
		const url = `/${this._url}/total-price`;
		return httpClient.post<BasketPricesForOrderTypes>(url, model);
	}

	getPrice(
		variantId: string,
		amount: number,
		amountUomId: string,
		contractualPartnerId?: number,
		isPromotionPackage = false
	): Observable<Price> {
		const url = `/${this._url}/price`;

		let contractualPartnerString = null;
		if (contractualPartnerId) {
			contractualPartnerString = contractualPartnerId.toString();
		}

		const params = `?productId=${variantId}&amount=${amount}&amountUomId=${amountUomId}&customerId=${contractualPartnerString}&isPromotionPackage=${isPromotionPackage}`;

		return httpClient.get<Price>(url + params);
	}

	getInventory(productId: string): Observable<Inventory> {
		const url = `/${this._url}/inventory`;
		const params = '?productIds=' + productId;

		return httpClient.get<Inventory>(url + params);
	}

	getOrderProposal(partnerIds: string): Observable<LocationProductOrderProposal[]> {
		const url = `/${this._url}/orderProposal?partnerIds=${partnerIds}`;

		return httpClient.get<LocationProductOrderProposal[]>(url);
	}

	getPaymentMethods(): Observable<PaymentMethod[]> {
		const url = `/${this._url}/paymentMethods`;

		return httpClient.get<PaymentMethod[]>(url);
	}

	getBasketView(basket: Basket): Observable<string> {
		const url = `/${this._url}/basket`;

		return httpClient.post<string>(url, basket);
	}
}
